export const SET_VARIABLE_CLIENTS = 'paye-bo/variableClients/SET_VARIABLE_CLIENTS'

const initialState = {
  variableClients: [],
}

export default function variableClientModule(state = initialState, action) {
  switch (action.type) {
    case SET_VARIABLE_CLIENTS:
      return { ...state, variableClients: action.value }
    default:
      return state
  }
}
